import React, { memo, useCallback } from "react";

const HealthListView = ({
  eventKey,
  setShow,
  show,
  data,
  selectedItem,
  isNotPointer,
  isSensor,
  showFour,
  showDiskNumber
}) => {
  console.count("HealthListView component render count: ");
  const handelItemClick = useCallback(() => {
    selectedItem(data);
  }, [data]);
  return (
    <tr
      onClick={
        eventKey.toLowerCase() === "Sensor".toLowerCase() || eventKey.toLowerCase() === "Non-Integrated-Devices".toLowerCase()
          ? null : handelItemClick
          // : handelItemClick
      }
    >
      <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {data?.CustomerName}
      </td>
      <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {data.SiteName}
      </td>
      <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {data.InterfaceName}
      </td>
      <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {isSensor ? data.DeviceName : data.DeviceName}
      </td>
      {/* <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {isSensor ? data.ZoneName : `${data.DeviceName} - ${data.DeviceId}`}
      </td> */}
      {/* <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
        {isSensor ? data.DeviceName : `${data.DeviceName ?? ""} - ${data.DeviceId ?? ""}`}
      </td> */}
      {showFour ? (
        <>
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {data.DeviceType}
          </td>
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {data.Abbreviation}
          </td>
        </>
      ) : (
        <>
          <td
            style={{ cursor: isNotPointer ? "default" : "pointer" }}
            className={
              data.DeviceStatus == "Online" ||
              data.DeviceStatus == "Normal" ||
              data.DeviceStatus == "Zone Restoral"
                ? "online-color"
                : data.DeviceStatus == "Zone Alert" ||
                  data.DeviceStatus == "Offline" ||
                  data.DeviceStatus == "Faulty"
                ? "offline-color" 
                : data.DeviceStatus == "Unknown" 
                ? "unknown-color"
                : data.DeviceStatus == "Unavailable" 
                ? "unavailable-color"
                : ""
            }
          >
            {data.DeviceStatus}
          </td>
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {data.Abbreviation}
          </td>
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {data.StatusDateTime}
          </td>
          {
            showDiskNumber &&
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {data.DiskNumber}
          </td>
          }
           {
            showDiskNumber &&
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {/* {data.TotalSpace} */}
            {/* {data.TotalSpace != null ? data.TotalSpace : "--"} */}
            {data.TotalSpace != null ? Number(data.TotalSpace).toLocaleString() : "--"}
          </td>
          }
           {
            showDiskNumber &&
          <td style={{ cursor: isNotPointer ? "default" : "pointer" }}>
            {/* {data.FreeSpace} */}
            {/* {data.FreeSpace != null ? data.FreeSpace : "--"} */}
            {data.FreeSpace != null ? Number(data.FreeSpace).toLocaleString() : "--"}
          </td>
          }
        </>
      )}
    </tr>
  );
};

export default memo(HealthListView);
